import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as loginActions from '../../actions/loginActionCreators';
import {Row, Col} from 'react-bootstrap';
import Footer from '../../components/common/Footer';
import Spinner from 'react-spinkit';


class ResetPasswordPage extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      message: ''
    }
  }

  componentWillMount() {
    if (this.props.reset != '') {
      this.resetPassword(this.props.reset);
    }
  }

  resetPassword(resetToken) {
    this.props.loginActions.sendNewPassword(resetToken)
      .then(() => {
        this.setState({message: 'A new password has been sent to your email account'});
      })
      .catch(() => {
        console.log('Some problem occurred');
        this.setState({message: 'Invalid reset link. Request another password.'});
      });
  }

  render() {
    return (
      <div className="container-fluid">
        <div className="text-center">
          <img className="mainLogo" src={require('../../images/logo.png')}/>
        </div>
        <Row>
          <Col md={12}>
            <div className="page-subtitle">Password Reset</div>
            <div className="notification-box">
              <h3>{this.state.message != '' ? this.state.message :
                <Spinner spinnerName="three-bounce" className="mt-4"/>}</h3>
            </div>
          </Col>
        </Row>
        <Footer/>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    state,
    reset: ownProps.location.query.reset
  };
}

function mapDispatchToProps(dispatch) {
  return {loginActions: bindActionCreators(loginActions, dispatch)}
}

export default connect(mapStateToProps, mapDispatchToProps)(ResetPasswordPage);



// WEBPACK FOOTER //
// ./src/components/login/ResetPasswordPage.js